<template>
    <div>
        <input :type="type" class="form-control" :id="id ? id : field"
               v-model="form[field]"
               :name="field"
               :class="[form.errors.has(field) ? 'is-invalid' : '', inputClass]"
               @change="handleChange"
               @keyup="handleKeyup"
        >
        <div class="invalid-feedback" v-if="form.errors.has(field)">
            {{form.errors.get(field)}}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: String,
            form: {
                type: Object,
                required: true
            },
            field: {
                type: String,
                required: true
            },
            inputClass: {
                type: String,
                default: 'base_input'
            },
            type: {
                type: String,
                default: 'text'
            }
        },
        methods: {
            handleChange() {
                this.$emit('change');
            },
            handleKeyup() {
                this.$emit('keyup');
            }
        },
    }
</script>

<style scoped>

</style>
